import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Newspaper } from "lucide-react";
import { CreatePost } from "@/components/CreatePost";
import { PostCard } from "@/components/PostCard";
import { DiwaliBanner } from "@/components/DiwaliBanner";
import { UserAvatar, VerifiedTick } from "@/components/UserAvatar";
import { Spinner, EmptyState } from "@/components/Loader";
import { api } from "@/lib/api";
import { isListedPro, professionOf } from "@/lib/constants";
import { useAuth } from "@/context/AuthContext";

function Suggested() {
  const [pros, setPros] = useState([]);
  const { user } = useAuth();
  useEffect(() => {
    api.get("/users/nearby", { params: { city: user?.city || undefined } })
      .then(({ data }) => setPros(data.filter((p) => isListedPro(p) && p.id !== user?.id).slice(0, 5)))
      .catch(() => {});
  }, [user]);
  if (!pros.length) return null;
  return (
    <div className="tm-card p-6" data-testid="suggested-pros">
      <h3 className="font-display font-bold text-tm-green">Professionals near you</h3>
      <div className="mt-4 space-y-3">
        {pros.map((p) => (
          <Link key={p.id} to={`/profile/${p.id}`} className="flex items-center gap-3 rounded-xl p-1 hover:bg-tm-muted" data-testid={`suggested-${p.id}`}>
            <UserAvatar user={p} size="sm" />
            <div className="min-w-0"><p className="flex items-center gap-1 truncate text-sm font-semibold">{p.full_name}<VerifiedTick user={p} /></p><p className="truncate text-xs text-slate-500">{professionOf(p)} · {p.city}</p></div>
          </Link>
        ))}
      </div>
      <Link to="/discover" className="mt-4 block text-sm font-semibold text-tm-green-light hover:underline">Discover more</Link>
    </div>
  );
}

export default function Feed() {
  const [posts, setPosts] = useState(null);
  const { user } = useAuth();
  useEffect(() => {
    api.get("/posts/feed").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);
  return (
    <div className="mx-auto grid max-w-6xl gap-6 lg:grid-cols-[minmax(0,1fr)_320px]">
      <div className="space-y-5">
        <div><p className="tm-eyebrow">Home feed</p><h1 className="mt-2 font-display text-2xl font-extrabold text-tm-green sm:text-3xl">Namaste, {user.full_name?.split(" ")[0]}</h1></div>
        <CreatePost onCreated={(p) => setPosts((ps) => [p, ...ps])} />
        {posts === null ? <Spinner /> : posts.length === 0 ? (
          <EmptyState icon={Newspaper} title="No posts yet" text="Be the first to share an update with the community." testid="feed-empty" />
        ) : posts.map((p) => <PostCard key={p.id} post={p} onDelete={(id) => setPosts((ps) => ps.filter((x) => x.id !== id))} />)}
      </div>
      <aside className="hidden space-y-5 lg:block">
        <DiwaliBanner compact />
        <Suggested />
      </aside>
    </div>
  );
}
